import { Typography } from "@mui/material";
import ColumnContainer from "../../../common/ColumnContainer";
import RowContainer from "../../../common/RowContainer";
import { TitleContainer, Wrapper } from "../../style";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import "./RedirectPageStyle.less";
import { DashboardButton } from "../../../common/DashboardButton";
import { useNavigate } from "react-router-dom";
import { userDashboardRoute } from "../../../../utils/routes/Routes";
import { FormattedMessage } from "react-intl";

const SuccessPage = () => {
  const navigate = useNavigate();
  const handleGoToHome = () => {
    navigate(userDashboardRoute.dashboardHome);
  };

  return (
    <Wrapper className="redirect-page">
      <ColumnContainer align="center" style={{ height: "100vh" }}>
        <ColumnContainer align="center" halfGap sx={{ gap: "40px" }}>
          <CheckCircleOutlineIcon
            fontSize="large"
            sx={{ "& path": { color: "var(--main-color)" } }}
          />
          <RowContainer align="center" center>
            <TitleContainer>
              <Typography variant="h4" component="h4">
                <FormattedMessage id="order.success" />
              </Typography>
            </TitleContainer>
          </RowContainer>
          {/* <RowContainer align="center" center>
            <Typography variant="h6" component="h6">
              <FormattedMessage id="order.confirm" />
            </Typography>
          </RowContainer> */}
          <RowContainer align="center" center>
            <DashboardButton type="filled" onClick={handleGoToHome}>
              <FormattedMessage id="button.backHome" />
            </DashboardButton>
          </RowContainer>
        </ColumnContainer>
      </ColumnContainer>
    </Wrapper>
  );
};
export default SuccessPage;
